import { Timeline } from "@/models/timeline.model";
import { MutationTree } from "vuex";
import { TimelineState } from ".";
import { PaginationResponse } from "./../../models/pagination.model";

export const TimelineMutationTypes = {
  SetTimeline: "SET_TIMELINE"
};

export const mutations: MutationTree<TimelineState> = {
  [TimelineMutationTypes.SetTimeline](state: TimelineState, payload: PaginationResponse<Timeline>) {
    state.timeline = payload.data;
    // TODO: Use .meta field when available
    state.paginationMeta = payload as any;
  }
};
